<template>
  <div class="wpcm-amount-box">
    <div class="wpcm-donation-amt-fields">
      <!-- Currency Select -->
      <div class="el-custom-select" v-if="show_currency_dropdown && currencies">
        <el-select class="w-100" :value="currency" @change="setValue('currency', $event)">
          <el-option :value="key" :key="key" :label="curr" v-for="(curr, key) in currencies">{{ curr }}</el-option>
        </el-select>
      </div>

      <!-- Custom Select -->
      <div class="el-custom-select" v-if="show_custom_dropdown">
        <el-select class="w-100" v-model="selectedCustom" @change="setValue('custom', $event)" placeholder="Select">
          <el-option v-for="(cus, key) in donation_custom_dropdown" :key="key" :value="key" :label="cus">
            {{ cus }}
          </el-option>
        </el-select>
      </div>

      <!-- Causes Select -->
      <div class="el-custom-select" v-if="show_causes_dropdown">
        <el-select class="w-100" v-model="selectedCause" @change="setValue('cause', $event)" placeholder="Select">
          <el-option v-for="(cause, key) in causes_list" :key="key" :value="key" :label="cause">
            {{ cause }}
          </el-option>
        </el-select>
      </div>

      <slot name="donation_dropdowns"></slot>

      <!-- Amount Title -->
      <div v-if="strings && show_amounts">
        <strong class="wpcm-cstm-amt-txt">{{ strings.how_much }}</strong>
      </div>

      <ul class="wpcm-pre-dfind-amt" v-if="show_amounts && amounts && !recurring">
        <li v-for="amnt in amounts" :key="amnt" @click.prevent="setValue('amount', convert(amnt))">
          <a href="#" :class="[
            'wpdonation-button',
            amount == convert(amnt) && 'active'
          ]">
            {{ getSymbol() }}{{ convert(amnt) }}</a>
        </li>
      </ul>

      <!-- Recurring Amounts -->
      <ul class="wpcm-pre-dfind-amt" v-if="show_amounts && amounts_recurring && recurring">
        <li v-for="amnt in amounts_recurring" :key="amnt" @click.prevent="setValue('amount', convert(amnt))">
          <a href="#" :class="[
            'wpdonation-button',
            amount == convert(amnt) && 'active'
          ]">
            {{ getSymbol() }}{{ convert(amnt) }}</a>
        </li>
      </ul>

      <!-- Reward Images -->
      <div class="wpcm-reward-images" v-if="show_reward_images && currentReward">
        <div class="reward-preview">
          <img :src="currentReward.image" :alt="currentReward.description" class="reward-image">
          <p class="reward-description">{{ currentReward.description }}</p>
        </div>
      </div>

      <!-- Display Amount -->
      <div v-if="!show_amount && display_amount">{{ `${getSymbol()} ${display_amount}` }}</div>
    </div>
  </div>
</template>

<script>
const { mapState, mapMutations } = window.Vuex;

export default {
  props: [
    "show_reward_images",
    "rewards_list",
    "donation_custom_dropdown",
    "currencies",
    "amounts",
    "strings",
    "show_currency_dropdown",
    "show_custom_dropdown",
    "show_amounts",
    "custom_amount",
    "show_recurring",
    "symbols",
    "symbol",
    "display_amount",
    "amounts_recurring",
    "show_amount",
    "show_causes_dropdown",
    "causes_list"
  ],

  data() {
    return {
      selectedCustom: null,
      selectedCause: null,
      rewardsData: [
        {
          amount: 10,
          image: 'https://lifeline.wpcharity.com/wp-content/uploads/2021/10/image-2.jpg',
          description: 'Donate $10 and receive a T-shirt!'
        },
        {
          amount: 40,
          image: 'https://lifeline.wpcharity.com/wp-content/uploads/2021/10/image-2.jpg',
          description: 'Donate $40 and receive our premium reward!'
        },
        {
          amount: 50,
          image: 'https://lifeline.wpcharity.com/wp-content/uploads/2021/10/mockup-1.jpg',
          description: 'Donate $50 and receive our special reward!'
        }
      ]
    };
  },

  computed: {
    ...mapState(["amount", "amount_recurring", "currency", "recurring", "custom"]),
    currentReward() {
      if (!this.amount) return null;
      return this.rewardsData.find(reward => 
        parseFloat(this.convert(reward.amount)) === parseFloat(this.amount)
      );
    }
  },

  mounted() {
    if (this.show_amounts && _.size(this.amounts_recurring)) {
      this.setValue('amount_recurring', this.amounts_recurring[0]);
    }
    if (this.show_amounts && _.size(this.amounts)) {
      this.setValue('amount', this.amounts[0])
    }
    if (this.show_currency_dropdown && _.size(this.currencies)) {
      this.setValue('currency', _.keys(this.currencies)[0])
    }
    if (this.display_amount) {
      this.setAmount(this.display_amount);
    }
  },

  methods: {
    ...mapMutations(["setAmount"]),
    setValue(key, val) {
      this.$store.commit("setValue", { key, val });
    },
    getSymbol() {
      return (this.symbols[this.currency] != undefined) ? this.symbols[this.currency] : this.symbol
    },
    convert(amt) {
      const { exchange_rates } = window.lifeline_donation
      const syb = this.currency

      if (_.get(exchange_rates, syb)) {
        return parseFloat(_.get(exchange_rates, syb) * amt).toFixed(2);
      }
      return amt
    }
  },
};
</script>

<style>
.wpcm-reward-images {
  margin-top: 20px;
  text-align: center;
}

.reward-preview {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-top: 10px;
}

.reward-image {
  max-width: 200px;
  height: auto;
  margin-bottom: 10px;
}

.reward-description {
  font-size: 14px;
  color: #666;
  margin: 5px 0;
}
</style>